export default class EmergencyPhone {
    constructor() {
        this.el = null;
    }
    init(el) {
        if (el === undefined || el === null) {
            return;
        }
        this.el = el;
        this.showOrHide();
    }
    showOrHide() {
        let show = false;
        if (
            this.el.getAttribute('data-phone') === undefined ||
            this.el.getAttribute('data-phone') === null ||
            this.el.getAttribute('data-phone') === ''
        ) {
            show = false;
        } else if (
            this.el.getAttribute('data-visible') === undefined ||
            this.el.getAttribute('data-visible') === null ||
            this.el.getAttribute('data-visible') === '' ||
            this.el.getAttribute('data-visible') === 'always'
        ) {
            show = true;
        } else if (
            this.el.getAttribute('data-openingtimes') === undefined ||
            this.el.getAttribute('data-openingtimes') === null ||
            this.el.getAttribute('data-openingtimes') === ''
        ) {
            show = true;
        } else {
            // check current opening times
            let openingtimes = JSON.parse(
                decodeURIComponent(this.el.getAttribute('data-openingtimes'))
            );
            Object.values(openingtimes).forEach((openingtimes__value) => {
                if (this.isOutside(openingtimes__value)) {
                    show = true;
                }
            });
        }
        if (show === true) {
            this.el.classList.remove('emergencyphone--hidden');
        } else {
            this.el.classList.add('emergencyphone--hidden');
        }
    }
    isOutside(openingtimes__value) {
        let d = new Date(),
            day = [
                'Sonntag',
                'Montag',
                'Dienstag',
                'Mittwoch',
                'Donnerstag',
                'Freitag',
                'Samstag',
                'Sonntag'
            ][d.getDay()],
            hours = d.getHours() + d.getMinutes() / 60;
        if (day !== openingtimes__value.day) {
            return false;
        }
        if (
            !('from' in openingtimes__value) ||
            !('until' in openingtimes__value) ||
            openingtimes__value.from.length !== 5 ||
            openingtimes__value.until.length !== 5
        ) {
            return false;
        }
        let hours_from =
            parseInt(openingtimes__value.from.substring(0, 2)) +
            parseInt(openingtimes__value.from.substring(3, 5)) / 60;
        let hours_until =
            parseInt(openingtimes__value.until.substring(0, 2)) +
            parseInt(openingtimes__value.until.substring(3, 5)) / 60;
        if (hours > hours_from && hours < hours_until) {
            return false;
        }
        return true;
    }
}
